import {
  Button,
  Checkbox,
  Container,
  ErrorText,
  FAB,
  Info,
  InputDate,
  Loading,
  Masks,
  RadioButton,
  Search,
  SectionTitle
} from '@elotech/components';
import { CpfCnpjInput, EnderecoForm } from 'itbi-common/components';
import { Constantes } from 'itbi-common/utils';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';

import { TipoPessoaEnum } from '../../enums';
import ContasVinculadasSection from './identity-provider/ContasVinculadasSection';
import LevelUp from './LevelUp';
import ResetPassword from './ResetPassword';
import UltimosLoginsSection from './UltimosLoginsSection';
import UserActiveSessionsSection from './UserActiveSessionsSection';
import VerificacaoDocumentosSection from './VerificacaoDocumentosSection';

const ConteudoTermo = styled.div`
  border: 1px solid #e0e0e0;
  text-align: justify;
  max-height: 200px;
  overflow-y: scroll;
  margin: 0 20px;
  padding: 5px 10px;
  white-space: pre-line;
`;
const tipoContaValues = [
  {
    key: 'PESSOAFISICA',
    value: 'FISICA',
    label: 'Pessoa Física'
  },
  {
    key: 'PESSOAJURIDICA',
    value: 'JURIDICA',
    label: 'Pessoa Jurídica'
  }
];

const labels = {
  FISICA: {
    dataLabel: 'Dados Pessoais',
    cpfCnpjLabel: 'CPF',
    nameLabel: 'Nome Completo'
  },
  JURIDICA: {
    dataLabel: 'Dados Empresariais',
    cpfCnpjLabel: 'CNPJ',
    nameLabel: 'Razão Social',
    alternateNameLabel: 'Nome Fantasia'
  }
};

const errorMessages = {
  'cpfCnpj-FISICA': 'O CPF é obrigatório.',
  'cpfCnpj-JURIDICA': 'O CNPJ é obrigatório.',
  'cpfCnpj-invalido-FISICA': 'CPF inválido.',
  'cpfCnpj-invalido-JURIDICA': 'CNPJ inválido.',
  'nome-FISICA': 'O nome é obrigatório.',
  'nome-JURIDICA': 'A razão social é obrigatória.',
  nomeFantasia: 'O nome fantasia é obrigatório.',
  email: 'O email é obrigatório.',
  termoResponsabilidade: 'O termo de responsabilidade é obrigatório.',
  telefoneObrigatorio: 'O telefone é obrigatório.',
  telefoneInvalido: 'Telefone inválido.',
  tipoProcurador: 'O tipo procurador é obrigatório.'
};

const Privacy = props => {
  const { onResetPassword } = props;
  return (
    <div>
      <SectionTitle>Privacidade e Segurança</SectionTitle>
      <Button type={'button'} onClick={onResetPassword}>
        REDEFINIR A SENHA
      </Button>
    </div>
  );
};

const AuthorizedUsers = props => {
  const {
    currentUser,
    authorizedUsers,
    searchText,
    onChangeSearch,
    onClear,
    loading,
    notFound,
    onAdd,
    onRemove,
    viewHistoryAuthorization
  } = props;
  return (
    <div>
      <SectionTitle hasButton={true}>
        Usuários Autorizados{' '}
        <button
          data-test-id="buttonNovo"
          className="btn module-color"
          onClick={viewHistoryAuthorization}
        >
          Histórico de Autorizações
        </button>
      </SectionTitle>

      <div className="outer-div row">
        <div className="col-md-3">
          <div className="form-group">
            <label className="label" htmlFor="authorized-user-search">
              Usuário
            </label>
            <Search
              type="text"
              name="authorized-user-search"
              id="authorized-user-search"
              onChange={onChangeSearch}
              value={searchText}
              maxLength={11}
              pattern="[0-9]*"
              loading={loading}
              placeholder="Pesquise por CPF"
              selected={!!currentUser}
              onClear={onClear}
              autoComplete="off"
            />

            {notFound && (
              <ErrorText className="help-message">
                Não foi possível encontrar nenhum usuário com o CPF informado.
              </ErrorText>
            )}
          </div>
        </div>

        {currentUser && (
          <React.Fragment>
            <div className="col-md-3">
              <div className="form-group">
                <label className="label">Nome</label>
                <label>{currentUser.nome}</label>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label className="label" />
                <button
                  type="button"
                  onClick={onAdd}
                  className="btn module-color"
                >
                  Adicionar
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      <div>
        {authorizedUsers.length > 0 && (
          <div className="table-editable">
            <div className="table-editable-header hidden-xs">
              <div className="row">
                <div className="col-md-2">CPF</div>
                <div className="col-md-9">Nome</div>
                <div className="col-md-1" />
              </div>
            </div>
            <div className="table-editable-content">
              {authorizedUsers.map((user, index) => (
                <div className="row" key={user.id}>
                  <div className="col-md-2 column" data-header="CPF">
                    {user.cpfCnpj}
                  </div>
                  <div className="col-md-9 column" data-header="Nome">
                    {user.nome}
                  </div>
                  <div className="col-md-1 column btn-actions">
                    <button onClick={onRemove(index)} className="btn">
                      <i className="fa fa-trash" />
                      <div className="btn-actions-label"> Excluir </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Term = props => {
  const { error, onChangeField, termoResponsabilidade, mostraCheckbox } = props;

  const [checkboxChecked, setCheckboxChecked] = useState(false);

  const onCheckboxChange = event => {
    setCheckboxChecked(event.target.checked);
    onChangeField(event);
  };

  return (
    <div>
      <SectionTitle>Termo de Responsabilidade</SectionTitle>

      {termoResponsabilidade?.conteudo && (
        <ConteudoTermo data-testid="conteudo-termo">
          {termoResponsabilidade.conteudo}
        </ConteudoTermo>
      )}

      {mostraCheckbox && (
        <p className="help-message ml-xs" style={{ fontSize: '14px' }}>
          Atenção! Leia o termo até o fim antes de aceitá-lo.
        </p>
      )}

      {mostraCheckbox && (
        <Checkbox
          id="term-agreement"
          name="termoResponsabilidade"
          checked={checkboxChecked}
          onChange={onCheckboxChange}
          label={'Li e aceito o Termo de Responsabilidade'}
          className="form-group"
        />
      )}

      {error.termoResponsabilidade && (
        <p className="help-message ml-xs" style={{ fontSize: '14px' }}>
          {errorMessages.termoResponsabilidade}
        </p>
      )}
    </div>
  );
};

const MyAccountForm = props => {
  const {
    user,
    userExists,
    userNivel,
    desabilitaEdicao,
    error,
    onChangeField,
    onChangeFieldMask,
    onSave,
    onAddAuthorizedUser,
    onChangeAuthorizedUserSearchText,
    onClearAuthorizedUser,
    onRemoveAuthorizedUser,
    userNotFound,
    authorizedUserSearchLoading,
    currentAuthorizedUser,
    authorizedUserSearchText,
    authorizedUsers,
    termoResponsabilidade,
    loadingSave,
    viewHistoryAuthorization,
    onChangeProcurador,
    onLevelUp,
    canLevelUp,
    showLevelUpForm,
    toggleLevelUpForm,
    isUsuarioPJValidoSemLoginComCertificadoDigital,
    identityProviders,
    acessoCidadaoPermitido,
    envioDocumentosHabilitado
  } = props;

  const {
    cpfCnpj,
    nome,
    nomeFantasia,
    dataNascimento,
    email,
    emailAlternativo,
    telefone,
    tipoPessoa,
    procurador,
    tipoProcurador,
    aceitouUltimoTermo,
    id: userId
  } = user;

  const userCannotEditSecondFields =
    isUsuarioPJValidoSemLoginComCertificadoDigital &&
    tipoPessoa === TipoPessoaEnum.JURIDICA;

  return (
    <Container title="Minha Conta">
      <Loading loading={loadingSave} />
      {userCannotEditSecondFields && (
        <Info classes={'mb-xs'} type={'warning'} beaty hasCloseButton>
          Para editar os campos de E-mail Alternativo e Telefone, é necessário
          logar na aplicação com o Certificado Digital.
        </Info>
      )}
      <SectionTitle marginTop="0px">
        {labels[tipoPessoa].dataLabel}
      </SectionTitle>
      <div className="row">
        <div className="form-group col-md-12">
          <RadioButton
            onChange={onChangeField}
            label="Tipo Conta"
            options={tipoContaValues}
            selectedValue={tipoPessoa}
            name="tipoPessoa"
            disabled={desabilitaEdicao}
          />
        </div>
      </div>
      <div className="row">
        <div className="form-group col-md-2">
          <label htmlFor="cpfCnpjInput" className="label">
            {labels[tipoPessoa].cpfCnpjLabel}
          </label>
          <CpfCnpjInput
            id="cpfCnpjInput"
            type="text"
            name="cpfCnpj"
            tipoPessoa={tipoPessoa}
            value={cpfCnpj}
            onChange={onChangeFieldMask}
            showMask={Boolean(cpfCnpj)}
            disabled={desabilitaEdicao}
            className={error.cpfCnpj || error.cpfCnpjInvalido ? 'error' : ''}
          />
          {error.cpfCnpj && (
            <ErrorText>{errorMessages[`cpfCnpj-${tipoPessoa}`]}</ErrorText>
          )}
          {error.cpfCnpjInvalido && (
            <ErrorText>
              {errorMessages[`cpfCnpj-invalido-${tipoPessoa}`]}
            </ErrorText>
          )}
        </div>

        <div className="form-group col-md-3">
          <label htmlFor="nameInput" className="label">
            {labels[tipoPessoa].nameLabel}
          </label>
          <input
            id="nameInput"
            type="text"
            value={nome}
            name="nome"
            onChange={onChangeField}
            className={error.nome ? 'error' : ''}
          />
          {error.nome && (
            <ErrorText>{errorMessages[`nome-${tipoPessoa}`]}</ErrorText>
          )}
        </div>

        {tipoPessoa === TipoPessoaEnum.JURIDICA && (
          <div className="form-group col-md-3">
            <label htmlFor="alternateNameInput" className="label">
              {labels[tipoPessoa].alternateNameLabel}
            </label>
            <input
              id="alternateNameInput"
              type="text"
              name="nomeFantasia"
              value={nomeFantasia}
              onChange={onChangeField}
              className={error.nomeFantasia ? 'error' : ''}
            />
            {error.nomeFantasia && (
              <ErrorText>{errorMessages.nomeFantasia}</ErrorText>
            )}
          </div>
        )}
        {tipoPessoa === TipoPessoaEnum.FISICA && (
          <div className="form-group col-md-2">
            <label htmlFor="dataNascimentoInput" className="label">
              Data de Nascimento <span className="optional">Opcional</span>
            </label>
            <InputDate
              alt="Data de Nascimento"
              id="dataNascimentoInput"
              value={dataNascimento}
              name="dataNascimento"
              onChange={onChangeField}
            />
          </div>
        )}
      </div>
      <div className="row">
        <div className="form-group col-md-3">
          <label htmlFor="emailInput" className="label">
            E-mail
          </label>
          <input
            id="emailInput"
            type="text"
            value={email}
            name="email"
            onChange={onChangeField}
            className={error.email ? 'error' : ''}
          />
          {error.email && <ErrorText>{errorMessages.email}</ErrorText>}
        </div>
        <div className="form-group col-md-3">
          <label htmlFor="emailAlternativoInput" className="label">
            E-mail alternativo<span className="optional">Opcional</span>
          </label>
          <input
            alt="E-mail alternativo"
            id="emailAlternativoInput"
            type="text"
            value={emailAlternativo}
            name="emailAlternativo"
            onChange={onChangeField}
            disabled={userCannotEditSecondFields}
          />
        </div>
        <div className="form-group col-md-2">
          <label htmlFor="telefoneInput" className="label">
            Telefone
          </label>
          <MaskedInput
            id="telefoneInput"
            type="text"
            value={telefone ?? ''}
            name="telefone"
            onChange={onChangeFieldMask}
            mask={Masks.MASK_TELEFONE}
            showMask={Boolean(telefone)}
            className={
              error.telefoneObrigatorio || error.telefoneInvalido ? 'error' : ''
            }
            disabled={userCannotEditSecondFields}
          />
          {(error.telefoneObrigatorio || error.telefoneInvalido) && (
            <ErrorText>
              {error.telefoneObrigatorio
                ? errorMessages.telefoneObrigatorio
                : errorMessages.telefoneInvalido}
            </ErrorText>
          )}
        </div>
      </div>
      <EnderecoForm
        endereco={user}
        errors={error}
        onChangeField={onChangeField}
        onChangeFieldMask={onChangeFieldMask}
      />
      {tipoPessoa === TipoPessoaEnum.JURIDICA && userExists && (
        <>
          <div className="row">
            <div className="form-group col-md-3">
              <Checkbox
                id="procurador"
                onChange={onChangeProcurador}
                label="Declaro que sou procurador"
                name="procurador"
                checked={procurador}
              />
            </div>
          </div>
          <div className="row">
            {procurador && (
              <div className="form-group col-md-3">
                <label htmlFor="tipoProcurador" className="label">
                  Tipo de Procurador
                </label>
                <select
                  id="tipoProcurador"
                  className={error.tipoProcurador ? 'error' : ''}
                  name="tipoProcurador"
                  value={tipoProcurador}
                  onChange={onChangeField}
                >
                  <option value="">Selecione</option>
                  {Constantes.optionsTipoProcurador.map(item => (
                    <option key={item.key} value={item.key}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {error.tipoProcurador && (
                  <ErrorText>{errorMessages.tipoProcurador}</ErrorText>
                )}
              </div>
            )}
          </div>
        </>
      )}

      <LevelUp
        onLevelUp={onLevelUp}
        userNivel={userNivel}
        showLevelUpForm={showLevelUpForm}
        canLevelUp={canLevelUp}
        toggleLevelUpForm={toggleLevelUpForm}
      />

      {acessoCidadaoPermitido === false && envioDocumentosHabilitado && (
        <Info classes={'mb-xs'} type={'warning'} beaty>
          Envie os documentos necessários para utilizar o Atendimento Cidadão.
        </Info>
      )}

      <VerificacaoDocumentosSection />

      {userExists && tipoPessoa === TipoPessoaEnum.JURIDICA && (
        <AuthorizedUsers
          onAdd={onAddAuthorizedUser}
          onChangeSearch={onChangeAuthorizedUserSearchText}
          onClear={onClearAuthorizedUser}
          onRemove={onRemoveAuthorizedUser}
          notFound={userNotFound}
          loading={authorizedUserSearchLoading}
          authorizedUsers={authorizedUsers}
          currentUser={currentAuthorizedUser}
          searchText={authorizedUserSearchText}
          viewHistoryAuthorization={viewHistoryAuthorization}
        />
      )}
      {userExists && <ResetPassword userId={userId} />}

      <ContasVinculadasSection
        idUsuario={userId}
        providersAssociados={identityProviders}
        allowConnect
      />

      <UserActiveSessionsSection />

      <UltimosLoginsSection />

      <Term
        onChangeField={onChangeField}
        termoAceito={user.termoResponsabilidade}
        error={error}
        termoResponsabilidade={termoResponsabilidade}
        mostraCheckbox={!userExists || !aceitouUltimoTermo}
      />

      <div className="btn-save">
        <FAB icon="check" iconColor="white" title="Salvar" onClick={onSave} />
      </div>
    </Container>
  );
};

AuthorizedUsers.propTypes = {
  searchText: PropTypes.string,
  currentUser: PropTypes.object,
  authorizedUsers: PropTypes.array,
  loading: PropTypes.bool,
  notFound: PropTypes.bool,
  onChangeSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};

Privacy.propTypes = {
  onResetPassword: PropTypes.func.isRequired
};

Term.propTypes = {
  termoAceito: PropTypes.bool,
  termoResponsabilidade: PropTypes.object,
  error: PropTypes.object,
  onChangeField: PropTypes.func.isRequired,
  mostraCheckbox: PropTypes.bool
};

MyAccountForm.propTypes = {
  authorizedUserSearchText: PropTypes.string,
  currentAuthorizedUser: PropTypes.object,
  authorizedUsers: PropTypes.array,
  termoResponsabilidade: PropTypes.object,
  user: PropTypes.object,
  error: PropTypes.object,
  userExists: PropTypes.bool,
  userNotFound: PropTypes.bool,
  authorizedUserSearchLoading: PropTypes.bool,
  onResetPassword: PropTypes.func.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onChangeFieldMask: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onAddAuthorizedUser: PropTypes.func.isRequired,
  onChangeAuthorizedUserSearchText: PropTypes.func.isRequired,
  onClearAuthorizedUser: PropTypes.func.isRequired,
  onRemoveAuthorizedUser: PropTypes.func.isRequired,
  desabilitaCpfCnpj: PropTypes.bool,
  onChangeProcurador: PropTypes.func.isRequired,
  acessoCidadaoPermitido: PropTypes.bool,
  envioDocumentosHabilitado: PropTypes.bool
};

export default MyAccountForm;
